import { parseQuery } from '@utils/utils'
import { platform,PLATFORM } from '@utils/device/platform'

const searchParams = new URLSearchParams(location.search)
const urlQuery = parseQuery()

/**
 * @description 读取login 根据不同环境获取 login status
 */
export const getIsLogin = () => {
  let result
  switch (platform) {
    case PLATFORM.WXAPP:
      return !!(searchParams.get('token') || urlQuery.token || localStorage.getItem('token')) || false
    case PLATFORM.APP:
      // eslint-disable-next-line
      // const appUserInfo = mfBridge.getAppUserInfo()
      // result = appUserInfo && JSON.parse(appUserInfo)
      return !!(searchParams.get('token') || urlQuery.token) || false
    case PLATFORM.WEB:
      return localStorage.getItem('isLogin') || false
    case PLATFORM.WECHAT:
    default: // web && default
      return localStorage.getItem('isLogin') || false
  }
}

/**
 *
 * @param { Boolean } 
 * @description 将 isLogin 写入本地localStorage中
 */
 export const setLogin = (val:any) => {
  return localStorage.setItem('isLogin', val)
}








